import translation from './en.json';

export default {
  translation
};